export default {
  CAE: "Contrat d'Accès et d'Exploitation (CAE)",
  CU_I: "Contrat Unique en Injection (CU-I)",
  CACSI: "Convention d’Autoconsommation Sans Injection (CACSI)",
}
